// import { defineCancelApiObject } from './configs/axiosUtils';
import { callApi } from '../../apiCaller';
import { toastError } from '../../utils';

const GENERAL_ENDPOINT = 'general';

export const GeneralAPI = {
     signUpCamsCareEmailGravityForm: async (payload, cancel = false) => {
          const endpoint = `${GENERAL_ENDPOINT}/sign-up-email-cams-care`;

          return await callApi(endpoint, 'POST', payload).then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               return response.data;
          });
     },
};

// // Defining the cancel API object for ZipcodeAPI
// const cancelApiObject = defineCancelApiObject(ZipcodeAPI);
